import type { TerminalType } from "src/app/features/TerminalProfile/types/TerminalProfileType";
import { FormComponent } from "../Form/types/types";

/**
 * AP3ADMIN-2356 This configurations should be placed into basic.json form definitions file.
 * So far, SearchForms are not included in JSON definitions.
 */

// TODO Create Factory

const commonSelectorConfig = {
    name: "",
    component: FormComponent.NO_ELEMENT,
    translationKeys: { label: "" },
};

export const statusSelectorConfig = {
    urlToFetchOptions: "/configurations/status",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const orgUnitStatusSelectorConfig = {
    urlToFetchOptions: "/configurations/org-unit-status",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const cardTypeSelectConfig = {
    urlToFetchOptions: "/configurations/application-profile-type-enum",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const terminalTypeSelectConfig = {
    urlToFetchOptions: "/configurations/terminal-type",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const terminalTemplateSelectConfig = {
    urlToFetchOptions: "/configurations/terminal-template",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const terminalProfileSelectConfig = {
    urlToFetchOptions: "/configurations/terminal-profile",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const siteSelectConfig = {
    urlToFetchOptions: "/configurations/site-id",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const terminalProfileIPTSelectConfig = (type: TerminalType) => ({
    urlToFetchOptions: `/configurations/terminal-profile?type=${type}`,
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
});

export const promptDataTypeSelectConfig = {
    urlToFetchOptions: "/configurations/prompt-data-type",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const acquirerProviderSelectConfig = {
    urlToFetchOptions: "/configurations/acquirer-provider",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const appProfileListSelectConfig = {
    urlToFetchOptions: "/configurations/app-profile-list",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const acquirerTypeSelectConfig = {
    urlToFetchOptions: "/configurations/acquirer-type",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const contractBaseSelectConfig = {
    urlToFetchOptions: "/configurations/contract-base",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const contractProfileSelectConfig = {
    urlToFetchOptions: "/configurations/contract-profile",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const siteGroupsSelectConfig = {
    urlToFetchOptions: "configurations/site-group-provider",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const appProfileCardTypeSelectConfig = {
    urlToFetchOptions: "/configurations/app-profiles-card-types",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const campaignTypeSelectorConfig = {
    urlToFetchOptions: "/configurations/campaign-types",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const campaignStateSelectorConfig = {
    urlToFetchOptions: "/configurations/campaign-states",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const dealerChangeLogStatusSelectorConfig = {
    urlToFetchOptions: "/configurations/dealer-change-log-statuses",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const productTypeSelectorConfig = {
    urlToFetchOptions: "/configurations/product-type",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const productItemTypeSelectorConfig = {
    urlToFetchOptions: "/configurations/product-item-type",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const dataGroupSelectorConfig = {
    urlToFetchOptions: "/configurations/data-group",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};

export const revisionTypeSelectorConfig = {
    urlToFetchOptions: "/configurations/revision-types",
    optionDisplayPropName: "key",
    optionValuePropName: "value",
    ...commonSelectorConfig,
};
